import React from 'react'
import styled from 'styled-components'
import Project from'./Project'

function Works() {
    return (
        <WorkWrapper id="works">
            <Wrapper>
         <Heading>
             <h2>Works</h2>
             <h1>LATEST PROJECTS</h1>
             <p>Here you can find some of my Projects that I created</p>
             <hr/>
         </Heading>

         <Project/>
        </Wrapper>
        </WorkWrapper>
    )
}

export default Works
const WorkWrapper=styled.div`
background-color:#e8eae6;
@media screen and (max-width:768px){
    margin-top:20px;
}

`;

const Wrapper=styled.div`
padding-top:10%;
padding-bottom:10%;
`;

const Heading=styled.div`
text-align:center;
h1{
    font-size:40px;
    letter-spacing:5px;
    word-spacing:2px;

}
h2{
    font-size:24px;
    letter-spacing:2px;
}
p{
    word-spacing:2px;
    letter-spacing:2px;
}
hr{
    width:15%;
    border:0.5px solid black;
}

@media screen and (max-width:768px){
  h1{
        font-size:30px;

    }
    h2{
        font-size:20px;

    }
    p{
        font-size:14px;
    }

}

`;

